import { render, staticRenderFns } from "./page.vue?vue&type=template&id=e4d6d798&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=e4d6d798&prod&scoped=true&lang=scss"
import style1 from "./page.vue?vue&type=style&index=1&id=e4d6d798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d6d798",
  null
  
)

export default component.exports